// @ts-strict-ignore
import get from "lodash/get";

import type { Entry, EntryCollection } from "contentful";

import type {
  ContentfulCoinDetailFields,
  ContentfulCryptopediaArticleType,
  ContentfulImage
} from "types/contentful";

export const getContentfulCoinContent = (
  content: EntryCollection<ContentfulCoinDetailFields>
): string => get(content, "items[0].fields.content", null);

export const getContentfulCoinName = (
  content: EntryCollection<ContentfulCoinDetailFields>
): string => get(content, "items[0].fields.name", null);

export const getContentfulCoin = (
  content: EntryCollection<ContentfulCoinDetailFields>
): string => get(content, "items[0].fields.coin", null);

export const getContentfulCoinSlug = (
  content: EntryCollection<ContentfulCoinDetailFields>
): string => get(content, "items[0].fields.slug", null);

export const buildImage = (imageEntry): ContentfulImage => ({
  // @See https://www.contentful.com/blog/2019/10/31/webp-source-sets-images-api/
  // for more infotmation on ?fm=webp parameter
  url: get(imageEntry.fields, "file.url", "") + "?fm=webp",
  fileName: get(imageEntry.fields, "file.fileName", ""),
  title: get(imageEntry.fields, "title", ""),
  contentType: get(imageEntry.fields, "file.contentType", "")
});

export const buildImageArray = (imageEntries): ContentfulImage[] => {
  return imageEntries.map(buildImage);
};

export const getEntriesFromRichText = (richText, entryTypeId = null) => {
  if (!richText) return [];
  const entries = richText.content.filter(
    (node) => node.nodeType === "embedded-entry-block"
  );
  const filteredEntries = entryTypeId
    ? entries.filter(
        (entry) => entry.data.target.sys.contentType.sys.id === entryTypeId
      )
    : entries;
  return filteredEntries.length
    ? filteredEntries.map((entry) => entry.data.target)
    : [];
};

export const getContentfulCryptopediaArticlesFromRichText = (
  richText
): ContentfulCryptopediaArticleType[] =>
  getEntriesFromRichText(richText, "cryptopediaPost");

export const validateEmpty = (value) => (value ? value : "");

export const flattenContentfulEntry = (entry: Entry<any>) => entry.fields;
